<template>
  <el-container style="width: 100%" v-loading="loading">
    <el-header height="70px">
      <el-row class="header">
        <el-col :xs="24"
                :sm="{span:14,offset:4}"
                class="text">远腾经销系统
        </el-col>
        <el-col :xs="0" :sm="{span:6}" class="problemInfo">
          问题咨询：400-638-6068
        </el-col>
      </el-row>
    </el-header>
    <el-container class="main-container">
      <el-aside>
        <el-row class="tac">
          <el-col>
            <el-menu
              :default-active="this.$route.path"
              class="el-menu-vertical-demo"
              :collapse="isCollapse"
              @select="handleSelect">
              <el-menu-item index="/findDealer">
                <i class="el-icon-suitcase-1"></i>
                <span slot="title">经销商资质查询</span>
              </el-menu-item>
              <el-menu-item index="/login">
                <i class="el-icon-tickets"></i>
                <span slot="title">客户报备系统</span>
              </el-menu-item>
              <el-menu-item index="/findExpress">
                <i class="el-icon-takeaway-box"></i>
                <span slot="title">快递信息查询</span>
              </el-menu-item>
            </el-menu>
          </el-col>
        </el-row>
      </el-aside>
      <el-main>
        <router-view/>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  export default {
    name: "yt",
    data() {
      return {
        activeIndex: '1',
        search: '',
        companyName: '',
        responsibleArea: '',
        contacts1: '',
        companyPhone: '',
        companyAddress: '',
        loading: true,
        isCollapse: false
      };
    },
    methods: {
      handleSelect(key, keyPath) {
        this.$router.push(key);
        // console.log(key, keyPath);
      },
      handleResize() {
        if (window.innerWidth < 768) {
          this.isCollapse = true;
        } else {
          this.isCollapse = false;
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        // console.log('页面加载完毕')
        this.loading = false;
      });
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    },
    created() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }
  }
</script>

<style scoped>
  .el-container {
    padding: 0;
    margin: 0;
  }

  .main-container {
    width: 60%;
    margin: auto;
    min-height: calc(100vh - 70px - 65px);
  }

  /deep/ .el-aside {
    max-width: 200px !important;
    overflow: hidden;
    height: auto;
  }

  .el-main {
    text-align: center;
  }

  .el-header {
    padding: 0;
    margin: 0;
    align-content: center;
  }

  .text {
    font-size: calc(2.2vw + 12px);
    line-height: 70px;
    color: #eeeeee;
    font-weight: 900;
    letter-spacing: 5px;
    text-align: center;
  }

  .problemInfo {
    line-height: 70px;
    color: #e2e2e2;
    font-size: calc(1vw + 2px);

  }

  .header {
    background-color: #2780d1;
    height: 100%;
    align-content: center;
    width: 100%;
    /*margin: 0 auto;*/
    text-align: center;
  }

  span:hover {
    color: #409EFF;
  }

  .el-menu-item {
    background-color: transparent;
  }

  .el-input {
    width: 180px;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    /*width: 100px;*/
    min-height: 400px;
  }

  @media screen and (max-width: 768px) {
    .main-container {
      width: 100%;
    }

    /deep/ .el-aside {
      width: auto !important;
    }

    .el-col-xs-0 {
      display: none;
      width: 0%;
    }
  }

  @media screen and (max-width: 1280px) and (min-width: 768px) {
    .main-container {
      width: 90%;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/yt.vue